<div class="modal">
  <div class="card card--md">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h3 class="card-title">{{ title }}</h3>
      <i class="fa fa-times pointer" (click)="onCancel()"></i>
    </div>
    <div class="card-body">
      <p class="text-muted mb-20">{{ description }}</p>

      <div *ngIf="!selectedFile">
        <label class="btn btn-orange pointer">
          <i class="fa fa-paperclip mr-2"></i> Dodaj fajl
          <input type="file" style="display: none;" accept=".xlsx,.xls" (change)="onFileChange($event)">
        </label>
      </div>

      <div *ngIf="selectedFile" class="d-flex align-items-center">
        <i class="fa fa-file-excel mr-2 text-green"></i>
        <span class="mr-3">{{ fileName }}</span>
        <i class="fa fa-times pointer text-red" (click)="onRemoveFile()"></i>
      </div>
    </div>
    <div class="card-footer">
      <button class="btn btn-secondary mr-2" (click)="onCancel()">Odustani</button>
      <button class="btn btn-orange" (click)="onImport()" [disabled]="!selectedFile">Uvezi</button>
    </div>
  </div>
</div>
